export enum FirebaseRegisterErrorType {
  EmailAlreadyInUse = 'auth/email-already-in-use',
  InvalidActionCode = 'auth/invalid-action-code',
}
